import { z } from 'zod';
export const LINK_SECRET_MAX_LENGTH = 256;
export const invitationDataSchema = z.object({
    id: z.string().uuid(),
    linkSecret: z.string().min(1).max(LINK_SECRET_MAX_LENGTH),
    isEncrypted: z.boolean(),
});
